module.exports = __webpack_public_path__ + "static/media/testStore.4072d650.svg";